import React from 'react';
import { motion } from 'framer-motion';

export const ProgressBar = ({ value, color, height = 4 }) => (
  <div style={{
    width: '100%', height, borderRadius: height,
    background: 'rgba(0,0,0,0.06)', overflow: 'hidden',
  }}>
    <motion.div
      initial={{ width: 0 }}
      animate={{ width: `${Math.max(2, value)}%` }}
      transition={{ duration: 0.6, ease: [0.23, 1, 0.32, 1] }}
      style={{
        height: '100%',
        background: color,
        borderRadius: height,
      }}
    />
  </div>
);
